export const DGDG_ORIGIN = "https://dgdg.app";
export const ENTREPOT_PROXY = "hdem4-ryaaa-aaaam-qa4xa-cai";
export const CAP_MARKET_CANISTER = "7oxg7-2iaaa-aaaah-qcguq-cai";
export const ICP_CANISTER_RE = /^[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}-cai$/i;
